import * as React from 'react';
import { RouteStore } from 'bernie-core';
import { KeyedObject } from 'bernie-core/dist/source';
import { ActivitySearchStore, FILTER_URL_PARAM_PREFIX } from '../../../stores';
import { getFilteredObjectKeys } from '../../../helpers/common-helper';
import { refreshAds } from '../../../utils/refresh-ads';

export const SEE_ALL_CATEGORY = 'seeAll';

export const getUpdatedFilterQueryObject = (activitySearchStore: ActivitySearchStore): any => {
  const filterQueryObject: KeyedObject = {};
  getFilteredObjectKeys(activitySearchStore.sortAndFilterObject.filters).forEach(sortAndFilterKey => {
    const filterKeys = getFilteredObjectKeys(activitySearchStore.sortAndFilterObject.filters[sortAndFilterKey]);
    const filterParamKey = FILTER_URL_PARAM_PREFIX + sortAndFilterKey;
    const filteredKeys = filterKeys.filter(
      filterKey => activitySearchStore.sortAndFilterObject.filters[sortAndFilterKey][filterKey].selected
    );
    if (sortAndFilterKey === SEE_ALL_CATEGORY && filteredKeys.length > 0) {
      filterQueryObject[filterParamKey] = true;
    } else {
      filterQueryObject[filterParamKey] = filteredKeys.join(',');
    }
  });

  return filterQueryObject;
};

export function seeAllCheckboxClickHandler(
  filterKey: string,
  filterCategoryId: string,
  activitySearchStore: ActivitySearchStore,
  routeStore: RouteStore,
  event: React.ChangeEvent<HTMLInputElement>,
  inDialog?: boolean
): void {
  const checked = event.target.checked;
  const updatedFilterState = Object.assign({}, activitySearchStore.sortAndFilterObject.filters);
  updatedFilterState[SEE_ALL_CATEGORY][SEE_ALL_CATEGORY] = { selected: checked, enabled: true };
  if (checked) {
    const filterState = { selected: !checked, enabled: true };
    const categoryKeys = getFilteredObjectKeys(activitySearchStore.sortAndFilterObject.filters);
    categoryKeys
      .filter(categoryKey => categoryKey !== SEE_ALL_CATEGORY)
      .forEach(categoryKey =>
        getFilteredObjectKeys(activitySearchStore.sortAndFilterObject.filters[categoryKey]).forEach(
          filterKey => (updatedFilterState[categoryKey][filterKey] = filterState)
        )
      );
  }
  activitySearchStore.sortAndFilterObject.filters = updatedFilterState;
  if (!inDialog) {
    const newQueryString = routeStore.mergeQueryString(routeStore.search, {
      ...getUpdatedFilterQueryObject(activitySearchStore)
    });
    routeStore.updateSearch(newQueryString, {}, true);
    refreshAds();
  }
}

export function checkboxClickHandler(
  filterKey: string,
  filterCategoryId: string,
  activitySearchStore: ActivitySearchStore,
  routeStore: RouteStore,
  event: React.ChangeEvent<HTMLInputElement>,
  inDialog?: boolean
): void {
  const checked = event.target.checked;
  const updatedFilterState = Object.assign({}, activitySearchStore.sortAndFilterObject.filters);
  if (checked) {
    updatedFilterState[filterCategoryId][filterKey] = { selected: checked, enabled: true };
    if (updatedFilterState[SEE_ALL_CATEGORY]) {
      updatedFilterState[SEE_ALL_CATEGORY][SEE_ALL_CATEGORY] = { selected: !checked, enabled: true };
    }
  }

  if (!checked) {
    const subCategoryKeys = getFilteredObjectKeys(
      activitySearchStore.sortAndFilterObject.filters[filterCategoryId],
      filterKey
    );
    subCategoryKeys.forEach(subCategory => {
      updatedFilterState[filterCategoryId][subCategory] = { selected: checked, enabled: true };
    });
  }
  activitySearchStore.sortAndFilterObject.filters = updatedFilterState;
  if (!inDialog) {
    const newQueryString = routeStore.mergeQueryString(routeStore.search, {
      ...getUpdatedFilterQueryObject(activitySearchStore)
    });
    routeStore.updateSearch(newQueryString, {}, true);
    refreshAds();
  }
}
